<template>
    <CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormFolio" role="form" method="post" autocomplete="off" onSubmit="return false">
                    <div class="form-group row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <label class="form-label" for="TipoFolio">Tipo de Folio</label>
                            <select :disabled="objFolio.IdFolio>0" @change="CambioFormulario()" class="form-control form-select" id="TipoFolio" v-model="objFolio.TipoFolio">
                                <option value="0">-- Seleccione un Folio --</option>
                                <option v-for="(item,index) in ListaTiposFolio" :value="item.IdTipoFolio" :key="index">{{ item.Nombre }}</option>
                            </select>
                        </div>
                    </div>
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<label class="form-label" for="Serie">Serie</label>
							<input type="text" v-model="objFolio.Serie" class="form-control" id="Serie" placeholder="Ingresar Serie" />
							<CValidation v-if="this.errorvalidacion.Serie" :Mensaje="'*'+errorvalidacion.Serie[0]"/>
						</div>

                        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<label class="form-label" for="Numero">Numero</label>
							<input type="text" v-model="objFolio.Numero" @input="$onlyNums($event,objFolio,'Numero');" class="form-control" id="Numero" placeholder="Ingresar Numero" />
							<CValidation v-if="this.errorvalidacion.Numero" :Mensaje="'*'+errorvalidacion.Numero[0]"/>
						</div>
					</div>
					
					<!-- <div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Nombre">Nombre</label>
							<input type="text" v-model="objFormapago.Nombre" class="form-control" id="Nombre" placeholder="Ingresar Nombre" />
							<CValidation v-if="this.errorvalidacion.Nombre" :Mensaje="'*'+errorvalidacion.Nombre[0]"/>
						</div>
					</div> -->
											
					<br>
                    
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>

export default {
    name: 'FormFolio',
    props: ['poBtnSave','TiposFolio','ListaFiltro'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objFolio: {
				IdFolio: 0,
                Nombre:'',
				Serie: '',
				Numero: '',
                TipoFolio:0,
				IdEmpresa: 0,
				IdSucursal: 0,
				
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			//masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
            MostrarCampos:false,
            ListaTiposFolio:this.TiposFolio
        }
    },
    methods :
    {
       	async Guardar()
        {
            // this.bus.$emit('AniadirFolio',this.objFolio);
            // this.bus.$emit('CloseModal_'+this.Emit);
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			if(this.objFolio.IdFolio == 0) {
				await this.$http.post(
					'folio',this.objFolio
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'folio/'+this.objFolio.IdFolio,
					this.objFolio
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "folio/"+this.objFolio.IdFolio
            ).then((res) => {
                this.objFolio = res.data.data;

				// en caso de que necesite fecha
				/*let formatedDate1 = this.objFormapago.Fecha.replace(/-/g,'\/');
                this.objFormapago.Fecha = new Date(formatedDate1);*/
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            // this.objFormapago = {
			// 	IdFormaPago: 0,
			// 	Clave: '',
			// 	Nombre: '',
			// 	IdEmpresa: 0,
			// 	IdSucursal: 0,
				
            // }
            // this.errorvalidacion = [];
        },
        // PROPIO
        CambioFormulario(){
            if (this.objFolio.TipoFolio>0) {
                this.MostrarCampos=true;
                this.objFolio.Nombre=this.TiposFolio.find(element=>element.IdTipoFolio==this.objFolio.TipoFolio).Nombre;
            }
            else{
                this.MostrarCampos=false;
            }
        }
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;
            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                this.objFolio.IdFolio = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
                this.ListaTiposFolio=this.ListaTiposFolio.filter(
                    (element)=>!this.ListaFiltro.some(
                        (el)=>el.TipoFolio==element.IdTipoFolio));
            }
        });
    }
}
</script>
